<template>
  <div>
    <div class="head">
      <div class="head_img">
        <img src="../assets/boloni.jpg" />
        <ul>
		  <li><a href="#" @click="one()">供货类型</a></li>
        </ul>
      </div>
    </div>
    <div class="main" :model="BasFrom" ref="form" style="height: 100%;">
      <div class="main_title">
        <span>框架合同信息档案收集</span>
      </div>
      <div class="item">
        <span class="item_title">请完善以下信息</span>
      </div>

      <div class="main_info">
		<table style="border-collapse: collapse; width: 100%; border: 0;">
			<!-- <tr>
				<th  style="width: 35%;">名称</th>
				<th>内容</th>
			</tr> -->
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>供应商编号:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.vendor_code" :disabled="true" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>供应商全称:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.vendor_name" :disabled="true" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>开户行:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.bank_name" :disabled="bReadonly" /></td>
			</tr>

			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>银行帐号:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.bank_no" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>联行号:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.yinlian_no" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>税号:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.tax_no" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>公司法人:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.fr_name" :disabled="bReadonly" /></td>
			</tr>

			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>法人联系方式:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.fr_phone" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>联系人<br>(用于日常对接、函件收取):</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.lxr_name" :disabled="bReadonly" /></td>
			</tr>

			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>联系人手机号:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.lxr_phone" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>传真:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.fax_no" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>邮编:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.post_code" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>邮箱:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.e_mail" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>地址:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.vendor_addr" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>隶属区域:</label></td>
				<td style="text-align: left;">
					<el-radio v-model="BasFrom.area_name" label="华北" style="width: 64px;text-align: left;" :disabled="bReadonly">华北</el-radio>
					<el-radio v-model="BasFrom.area_name" label="华中" style="width: 64px;text-align: left;" :disabled="bReadonly">华中</el-radio>
					<el-radio v-model="BasFrom.area_name" label="华东" style="width: 64px;text-align: left;" :disabled="bReadonly">华东</el-radio>
					<el-radio v-model="BasFrom.area_name" label="华南" style="width: 64px;text-align: left;" :disabled="bReadonly">华南</el-radio>
					<el-radio v-model="BasFrom.area_name" label="华西" style="width: 64px;text-align: left;" :disabled="bReadonly">华西</el-radio>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>所属城市:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.city_name" :disabled="bReadonly" /></td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>税率:</label></td>
				<td style="text-align: left;">
					<el-radio v-model="BasFrom.tax_rate" label="13%" style="width: 32px;" :disabled="bReadonly">13%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="16%" style="width: 32px;" :disabled="bReadonly">16%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="17%" style="width: 32px;" :disabled="bReadonly">17%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="10%" style="width: 32px;" :disabled="bReadonly">10%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="11%" style="width: 32px;" :disabled="bReadonly">11%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="1%" style="width: 32px;" :disabled="bReadonly">1%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="3%" style="width: 32px;" :disabled="bReadonly">3%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="4%" style="width: 32px;" :disabled="bReadonly">4%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="5%" style="width: 32px;" :disabled="bReadonly">5%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="6%" style="width: 32px;" :disabled="bReadonly">6%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="7%" style="width: 32px;" :disabled="bReadonly">7%</el-radio>
					<el-radio v-model="BasFrom.tax_rate" label="9%" style="width: 32px;" :disabled="bReadonly">9%</el-radio>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>账期信息:</label></td>
				<td style="text-align: left;">
					<el-checkbox-group  v-model="zq_checkList" @change="handleCheckedZQOptionChange" style="width: 60%;margin-left: 1px;" :disabled="bReadonly">
						<el-checkbox label="月结算" style="display: flex;"></el-checkbox>
						<el-checkbox label="预付款" style="display: flex;"></el-checkbox>
						<el-checkbox label="其它约定" style="display: flex;"></el-checkbox>
					</el-checkbox-group>	
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>账期(天)<br>与我司目前合作账期,填写天数:</label></td>
				<td style="text-align: left;">
					<input type="number" style="width: 80%;" placeholder="请输入数字" v-model="BasFrom.zq_days" :disabled="bReadonly"/>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>账期另行约定说明:</label></td>
				<td style="text-align: left;">
					<input type="text" style="width: 80%;" v-model="BasFrom.fk_other_note" :disabled="bReadonly"/>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>按月为周期结算<br>(月结算),账期天:</label></td>
				<td style="text-align: left;">
					<el-radio v-model="BasFrom.yjs_note" label="30" style="width: 200px;" :disabled="bReadonly">按月为周期结算(月结算),账期30天</el-radio>
					<el-radio v-model="BasFrom.yjs_note" label="60" style="width: 120px;" :disabled="bReadonly">按月为周期结算(月结算),账期60天</el-radio>
				</td>
			</tr>
			<!-- <tr>
				<td style="text-align: right;"><label><span class="Required">*</span>预付款条件:</label></td>
				<td style="text-align: left;">
					本订单签订之日起
					<input type="text" v-model="BasFrom.yfk_date" style="width: 20px;border-color: red;" :disabled="bReadonly"/>日内甲方向乙方支付订单总金额的
					<input type="text" v-model="BasFrom.yfk_rate" style="width: 20px;border-color: red;" :disabled="bReadonly"/>%作为预付款，对账后付
					<input type="text" v-model="BasFrom.yfk_wk_rate"  style="width: 20px;border-color: red;" :disabled="bReadonly"/>%尾款，质保金
					<input type="text" v-model="BasFrom.yfk_zbj_rate"  style="width: 20px;border-color: red;" :disabled="bReadonly"/>%，账期
					<input type="text" v-model="BasFrom.yfk_zq"  style="width: 20px;border-color: red;" :disabled="bReadonly"/>天，质保
					<input type="text" v-model="BasFrom.yfk_zbq" style="width: 20px;border-color: red;" :disabled="bReadonly"/>个月
				</td>
			</tr> -->
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>付款方式<br>(目前与我司合作使用的付款方式):</label></td>
				<td style="text-align: left;">
					<el-checkbox-group  v-model="pay_type_checkList" @change="handleCheckedPayTypeOptionChange" style="width: 50%;" :disabled="bReadonly">
							<el-checkbox label="电汇" style="display: flex;"></el-checkbox>
							<el-checkbox label="支票" style="display: flex;"></el-checkbox>
							<el-checkbox label="商业承兑汇票" style="display: flex;"></el-checkbox>
							<el-checkbox label="银行承兑汇票" style="display: flex;"></el-checkbox>
					</el-checkbox-group>
				</td>
			</tr>
			<!-- <tr>
				<td style="text-align: right;"><label><span class="Required">*</span>质保期(月) <br>(一般为30个月):</label></td>
				<td style="text-align: left;">
					<input type="number" style="width: 80%;" placeholder="请输入数字" v-model="BasFrom.zb_days" :disabled="bReadonly"/>
				</td>
			</tr> -->
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>质保金付款方式:</label></td>
				<td style="text-align: left;">
					<el-radio v-model="BasFrom.bzjfk_type" label="现金、支票、电汇支付" style="width: 150px;text-align: left;" :disabled="bReadonly">现金、支票、电汇支付</el-radio>
					<el-radio v-model="BasFrom.bzjfk_type" label="货款中扣除" style="width: 64px;text-align: left;" :disabled="bReadonly">货款中扣除</el-radio>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>质保约定说明:</label></td>
				<td style="text-align: left;">
					<input type="text" style="width: 80%;" v-model="BasFrom.zb_note" :disabled="bReadonly"/>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>已缴纳质保金(元)<br>(目前已经在博湖北缴纳的质保金金额(确保准确)):</label></td>
				<td style="text-align: left;">
					<input type="number" style="width: 80%;" placeholder="请输入数字" v-model="BasFrom.bzj_payed" :disabled="bReadonly"/>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span> 产品包装:</label></td>
				<td style="text-align: left;">
					<el-radio v-model="BasFrom.box_type" label="原厂包装" style="width: 120px;text-align: left;" :disabled="bReadonly">原厂包装</el-radio>
				<el-radio v-model="BasFrom.box_type" label="中性包装" style="width: 120px;text-align: left;" :disabled="bReadonly">中性包装</el-radio>
				<el-radio v-model="BasFrom.box_type" label="约定包装" style="width: 120px;text-align: left;" :disabled="bReadonly">约定包装</el-radio>
			
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>约定包装说明:</label></td>
				<td style="text-align: left;">
					<input type="text" style="width: 80%;" v-model="BasFrom.box_note" :disabled="bReadonly"/>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>供货类型:</label></td>
				<td style="text-align: left;">
					<el-checkbox-group  v-model="vendor_type_checkList" @change="handleCheckedVendorTypeOptionChange" :disabled="bReadonly">
						<el-checkbox label="原材料" style="text-align: left;"></el-checkbox>
						<el-checkbox label="外协" style="text-align: left;"></el-checkbox>
						<el-checkbox label="台面" style="text-align: left;"></el-checkbox>
					</el-checkbox-group>	
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>供货品类:</label></td>
				<td style="text-align: left;">
					<el-checkbox-group v-model="cp_type_checkList"  @change="handleCheckedCPTypeOptionChange" :disabled="bReadonly" style="margin-right: 180px;">
						<el-checkbox v-for="op in cp_type_zqoptions" :label="op" :key="op" style="width: 60px;">{{op}}</el-checkbox>
					</el-checkbox-group>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"><label><span class="Required">*</span>合同回寄信息:</label></td>
				<td style="text-align: left;"><input type="text" style="width: 80%;" v-model="BasFrom.hthj_addr" :disabled="bReadonly" /></td>
			</tr>
		</table>
        <div class="Supply_Type"> 
          <div class="Supply_Type_button" >
			<button type="button" @click="save()" v-show="!bReadonly"><span>保存</span></button>
            <button
              type="button"
              @click="submit()"
              style="background-color: #27eaff" 
			  v-show="bSaved && !bReadonly">
              <span>提交</span>
            </button>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		savegyshtzl,
		getgyshtzl,
		submithtzl,
		getGys,
		getgyszr
	} from "../api/LoginApi";
	import { goBack, Transformation } from "../utils/Transformation";
	import { getThisYearMonthDays } from "../utils/date";
	import { messageError, messageSuCcEss } from "../utils/message";
	import "vue-multiselect/dist/vue-multiselect.min.css";
	import Multiselect from "vue-multiselect";
	export default {
	components: {
		Multiselect,
	},
	name: "Gysfcia",
	data: function () {
		return {
			BasFrom: {
				gys_no: localStorage.getItem("userName"),
				vendor_code: localStorage.getItem("userName"),
				vendor_name: localStorage.getItem("name_all"),
				bank_name: "",
				bank_no: "",
				yinlian_no: "",
				tax_no: "",
				fr_name: "",
				fr_phone: "",
				lxr_name: "",
				lxr_phone: "",
				fax_no: "",
				post_code: "",
				e_mail: "",
				vendor_addr: "",
				city_name: "",
				area_name: "",
				tax_rate: "13%", 
				zq_days: "",
				fk_other_note: "",
				yjs_note: "",
				yfk_note: "",
				pay_type: "",
				// zb_days: "",
				bzjfk_type: "",
				zb_note: "",
				bzj_payed: "",
				box_type: "",
				box_note: "",
				vendor_type: "",
				cp_type: "",
				hthj_addr: "",
				zq_note: "",
				// yfk_date: "20",//预付款支付日期
				// yfk_rate: "30",//预付款比率
				// yfk_wk_rate: "65",//尾款比例
				// yfk_zbj_rate: "5",//质保金比率
				// yfk_zq: "60", //账期
				// yfk_zbq: "30" //质保期
			},
			zq_checkList: [],
			cp_type_checkList: [],
			pay_type_checkList: [],//付款方式列表
			vendor_type_checkList: [],//供货类型
			zqoptions: ["月结算","预付款","其他约定"],
			checkList: ['选中且禁用','复选框 A'],
			cp_type_zqoptions: ["板材料类","加工类","包装材料","大五金配件","化工类","金属材料","拉手类","灯   类","小五金辅料","电器类","塑胶/PV","生产辅料","内门类","外门类","不锈钢","板式类","陶瓷洁具","铝材类","软装类","玻璃类","其他外协类","石英石","人造石","天然石","岗    石","岩     板","水     盆","加工安装","其他"],
			optionsGhdl: [], // 供货大类列表
			optionsGhType: [], // 供货小类列表
			optionsProvNice: [], // 省份列表
			optionsCity: [], // 城市列表
			ghdl_data: [], // 供货大类数据存储
			ghtype_data: [], // 供货小类数据存储
			bReadonly: false, //是否只读状态
			bSaved: false //是否保存过资料
		};
	},
	created() {
		this.getBasic();
	},
	mounted() {
		// 默认时间
		//this.BasFrom.gys_time = getThisYearMonthDays(new Date(), "yyyy-mm-dd");
		//this.BasFrom.gys_jynx = this.BasFrom.gys_time.substring(0, 4);
		// 页面刷新时清除localStorage
		window.onbeforeunload = function (e) {
			let storage = window.localStorage;
			storage.clear();
		};
		// localStorage不存在loginguid则跳到登录页面
		if (!localStorage.getItem("loginguid")) {
			const vm = this;
			vm.$router.push({
				path: "/Login",
			});
		}
		// 不允许使用页面返回按钮
		if (window.history && window.history.pushState) {
			// 向历史记录中插入了当前页
			history.pushState(null, null, document.URL);
			window.addEventListener("popstate", goBack, false);
		}
	},
	destroyed() {
		window.removeEventListener("popstate", goBack, false);
	},
	methods: {
		one() {
			const vm = this
			vm.$router.push({
				path: '/GysBasic'
			})
		},
		//处理账期勾选事件
		handleCheckedZQOptionChange(value) { 
			//  console.log("zq_checkList: ", this.zq_checkList);
			 this.BasFrom.zq_note = "";
			 if(value && value.length > 0){ 
				for(var i = 0; i < value.length; i++){
					if(i == 0){
						this.BasFrom.zq_note = value[i];
					}else{
						this.BasFrom.zq_note += ";" + value[i];
					}
				}
			 }
        },
		//处理付款方式勾选事件
		handleCheckedPayTypeOptionChange(value) { 
			//  console.log("pay_type_checkList: ", this.pay_type_checkList);
			 this.BasFrom.pay_type = "";
			 if(value && value.length > 0){ 
				for(var i = 0; i < value.length; i++){
					if(i == 0){
						this.BasFrom.pay_type = value[i];
					}else{
						this.BasFrom.pay_type += ";" + value[i];
					}
				}
			 }
        },
		//处理供货类型勾选事件
		handleCheckedVendorTypeOptionChange(value) { 
			//  console.log("vendor_type_checkList: ", this.vendor_type_checkList);
			 this.BasFrom.vendor_type = "";
			 if(value && value.length > 0){ 
				for(var i = 0; i < value.length; i++){
					if(i == 0){
						this.BasFrom.vendor_type = value[i];
					}else{
						this.BasFrom.vendor_type += ";" + value[i];
					}
				}
			 }
        },
		//处理供货品类勾选事件
		handleCheckedCPTypeOptionChange(value) { 
			//  console.log("cp_type_checkList: ", this.cp_type_checkList);
			 this.BasFrom.cp_type = "";
			 if(value && value.length > 0){ 
				for(var i = 0; i < value.length; i++){
					if(i == 0){
						this.BasFrom.cp_type = value[i];
					}else{
						this.BasFrom.cp_type += ";" + value[i];
					}
				}
			 }
        },
		// 窗体加载查询数据
		getBasic: function () {
			// 查询供应商合同资料
			getgyshtzl(localStorage.getItem("name_all")).then((res) => {
				if (res) {
					this.BasFrom = res;
					let that = this;
					if(this.BasFrom.zq_note && this.BasFrom.zq_note.length > 0){
						let zanotes = this.BasFrom.zq_note.split(";");
						let zqchecklist = []; 
						zanotes.forEach(function(item,index,arr){
							that.zq_checkList.push(item);
						})
					}

					if(this.BasFrom.pay_type && this.BasFrom.pay_type.length > 0){
						let paytypes = this.BasFrom.pay_type.split(";");
						paytypes.forEach(function(item,index,arr){
							that.pay_type_checkList.push(item);
						})
					}

					if(this.BasFrom.vendor_type && this.BasFrom.vendor_type.length > 0){
						let vendortypes = this.BasFrom.vendor_type.split(";"); 
						vendortypes.forEach(function(item,index,arr){
							that.vendor_type_checkList.push(item);
						})
					}

					if(this.BasFrom.cp_type && this.BasFrom.cp_type.length > 0){
						let cptypes = this.BasFrom.cp_type.split(";");						 
						cptypes.forEach(function(item,index,arr){
							that.cp_type_checkList.push(item);
						})
					}
					this.bSaved = true;
					//提交后设置只读状态
					if(2 == res.submit_stat){
						this.bReadonly = true;
					}
				}else{
					// 查询所有数据
					// getGys(localStorage.getItem("userName")).then((res) => {
					// 	if (res) {
					// 	//    this.BasFrom.vendor_code = res.gys_no;
					// 	   this.BasFrom.vendor_name = res.name_all;
					// 	//    this.BasFrom.bank_name = res.bank_name;
					// 	//    this.BasFrom.bank_no = res.bank_num;
					// 	//    this.BasFrom.yinlian_no = res.cnaps_code;
					// 	//    this.BasFrom.lxr_name = res.lxr_name;
					// 	//    this.BasFrom.lxr_phone = res.lxr_phone;
					// 	//    this.BasFrom.vendor_addr = res.vendor_addr;

					// 	   //查询供应商是否可以提交合同资料
					// 		getgyszr(localStorage.getItem('userName')).then(res => {
					// 			if (res) {
					// 				this.BasFrom.vendor_name = res.vendor_name;
					// 				this.BasFrom.vendor_code = res.vendor_code; 
					// 				this.BasFrom.lxr_name = res.lxr_name;
					// 				this.BasFrom.lxr_phone = res.lxr_phone;
					// 				this.BasFrom.vendor_addr = res.vendor_addr; 
					// 				this.BasFrom.bank_name = res.bank_name;
					// 	   			this.BasFrom.bank_no = res.bank_no;
					// 	   			this.BasFrom.yinlian_no = res.yinlian_no;
					// 			}
					// 		})
					// 	}
					// })

					//查询供应商是否可以提交合同资料
					getgyszr(localStorage.getItem('name_all')).then(res => {
								if (res) {
									this.BasFrom.vendor_name = res.vendor_name;
									this.BasFrom.vendor_code = res.vendor_code; 
									this.BasFrom.lxr_name = res.lxr_name;
									this.BasFrom.lxr_phone = res.lxr_phone;
									this.BasFrom.vendor_addr = res.vendor_addr; 
									this.BasFrom.bank_name = res.bank_name;
						   			this.BasFrom.bank_no = res.bank_no;
						   			this.BasFrom.yinlian_no = res.yinlian_no;
								}
					})
				}
			}) 
		},
		//保存数据
		save: function () {
			// console.log("obj: ", this.BasFrom);
			let message = ""; 
			if (!this.BasFrom.bank_name && this.BasFrom.bank_name.length < 1) {
				message += "[开户行]不能为空！";
			}
			if (!this.BasFrom.bank_no && this.BasFrom.bank_no.length < 1) {
				message += "[银行帐号]不能为空!";
			}
			if (!this.BasFrom.yinlian_no && this.BasFrom.yinlian_no.length < 1) {
				message += "[联行号]不能为空!";
			}
			if (!this.BasFrom.tax_no && this.BasFrom.tax_no.length < 1) {
				message += "[税号]不能为空!";
			}
			if (!this.BasFrom.fr_name && this.BasFrom.fr_name.length < 1) {
				message += "[公司法人]不能为空!";
			}
			if (!this.BasFrom.fr_phone && this.BasFrom.fr_phone.length < 1) {
				message += "[法人联系方式]不能为空!";
			}
			if (!this.BasFrom.lxr_name && this.BasFrom.lxr_name.length < 1) {
				message += "[联系人]不能为空!";
			}
			if (!this.BasFrom.lxr_phone && this.BasFrom.lxr_phone.length < 1) {
				message += "[联系人手机号]不能为空!";
			}
			if (!this.BasFrom.fax_no && this.BasFrom.fax_no.length < 1) {
				message += "[传真]不能为空!";
			}
			if (!this.BasFrom.post_code && this.BasFrom.post_code.length < 1) {
				message += "[邮编]不能为空!";
			}
			if (!this.BasFrom.vendor_addr && this.BasFrom.vendor_addr.length < 1) {
				message += "[地址]不能为空！";
			}
			if (!this.BasFrom.city_name && this.BasFrom.city_name.length < 1) {
				message += "[所属城市]不能为空！";
			}
			if (!this.BasFrom.area_name && this.BasFrom.area_name.length < 1) {
				message += "[隶属区域]不能为空！";
			}
			if (!this.BasFrom.tax_rate && this.BasFrom.tax_rate.length < 1) {
				message += "[税率]不能为空！";
			}
			if (!this.BasFrom.zq_note && this.BasFrom.zq_note.length < 1) {
				message += "[账期信息]不能为空！";
			}
			if (!this.BasFrom.zq_days && this.BasFrom.zq_days.length < 1) {
				message += "[账期]不能为空！";
			}
			if (!this.BasFrom.yjs_note && this.BasFrom.yjs_note.length < 1) {
				message += "[按月为周期结算(月结算),账期天]不能为空！";
			}
			/**
			if (!this.BasFrom.yfk_date && this.BasFrom.yfk_date.length < 1
				|| !this.BasFrom.yfk_rate && this.BasFrom.yfk_rate.length < 1
				|| !this.BasFrom.yfk_wk_rate && this.BasFrom.yfk_wk_rate.length < 1
				|| !this.BasFrom.yfk_zbj_rate && this.BasFrom.yfk_zbj_rate.length < 1
				|| !this.BasFrom.yfk_zq && this.BasFrom.yfk_zq.length < 1
				|| !this.BasFrom.yfk_zbq && this.BasFrom.yfk_zbq.length < 1) {
				message += "[预付款条件]不能为空！";
			}
			*/
			if (!this.BasFrom.pay_type && this.BasFrom.pay_type.length < 1) {
				message += "[付款方式]不能为空！";
			}
			// if (!this.BasFrom.zb_days && this.BasFrom.zb_days.length < 1) {
			// 	message += "[质保期(月)]不能为空！";
			// }
			if (!this.BasFrom.bzjfk_type && this.BasFrom.bzjfk_type.length < 1) {
				message += "[保金付款方式]不能为空！";
			}
			if (!this.BasFrom.zb_note && this.BasFrom.zb_note.length < 1) {
				message += "[质保约定说明]不能为空！";
			}
			if (!this.BasFrom.bzj_payed && this.BasFrom.bzj_payed.length < 1) {
				message += "[已缴纳质保金]不能为空！";
			}
			if (!this.BasFrom.box_type && this.BasFrom.box_type.length < 1) {
				message += "[产品包装]不能为空！";
			}
			if (!this.BasFrom.box_note && this.BasFrom.box_note.length < 1) {
				message += "[约定包装说明]不能为空！";
			}
			if (!this.BasFrom.vendor_type && this.BasFrom.vendor_type.length < 1) {
				message += "[供货类型]不能为空！";
			}
			if (!this.BasFrom.cp_type && this.BasFrom.cp_type.length < 1) {
				message += "[供货品类]不能为空！";
			}
			if (!this.BasFrom.hthj_addr && this.BasFrom.hthj_addr.length < 1) {
				message += "[合同回寄信息]不能为空！";
			} 

			if (message.length > 0) {
				return messageError(message)
			}


			savegyshtzl(this.BasFrom).then((res) => {
				if (res.code === 200) { 
					this.bSaved = true;
					return messageSuCcEss(res.msg);
				} else {
					return messageError(res.msg);
				}
			});
		},
		//提交
		submit: function(){
			submithtzl(localStorage.getItem("name_all")).then((res) => {
				if (res.code === 200) { 
					this.bReadonly = true;
					return messageSuCcEss(res.msg);
				} else {
					return messageError(res.msg);
				}
			}) 
		}
	}
};
</script>


<style scoped>
@import "../css/Main.css";

label {
	font-size: 15px;
	display: inline-block;
	padding: 3px 6px;
	text-align: right;
	width: 150px;
	vertical-align: top;
}

table > tr > td {
  border: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Gysfcia.vue